import React from "react";
import { InfoCircleOutlined } from "@ant-design/icons";

/**
 * Ant Design `Form.Item` tooltip config matching Figma's information-circle
 * chrome (grey-600 “i” icon) instead of the default black question mark.
 */
export const formFieldTooltip = (title: string) => ({
  title,
  icon: <InfoCircleOutlined aria-hidden />,
});
